import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Button, Modal, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import CrossIcon from "../../../assets/img/file-cut-icon.png";
import { useDispatch } from "react-redux";
import useCredentialData from "../../../hooks/useCredentialData";
import SearchSelect from "../../../components/forms/SearchSelect";
import { useForm } from "react-hook-form";
import { updateEmployeeProfileDetails } from "../../../redux/slice/updateEmployeeProfileSlice"
import { fetchUserById } from "../../../redux/slice/getUserByIdSlice";

export default function EmployeeCredentialEditModal({
  show,
  onHide,
  canEdit,
  employee,
  hasRolePermission,
  employeeId
}) {
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    control,
  } = useForm();

  const { workingModeShift, designation, roles, department, activeEmp } = useCredentialData(show && hasRolePermission);

  console.log("dataaaaaa ",  show,
  onHide,
  canEdit,
  employee,
  hasRolePermission,roles);

  useEffect(() => {
console.log("useEffect",show,employee,department,roles)
    if (show && employee && (department?.length > 0 || roles?.length > 0)) {
      reset({
        employmentType: employee.empType || "",
        roleId: employee.roleId || "", 
        desg: employee.designation || "",
        dept: employee.department || "",
        reportingManager: employee.reportManager || "",
        teamLead: employee.teamLead || "",
        workingMode: employee.workingMode || "",
        shiftTime: employee.shiftTime || "",
        jobLocation: employee.officeLocation || "",
        abtEmp: employee.aboutUs || "",
      });
    }
  }, [
    show,
    employee,
    reset,
    roles,
    department,
    designation,
    activeEmp,
    workingModeShift,
  ]);


  if (show && !hasRolePermission) {
    return (
      <Modal show={show} onHide={onHide} size="md">
        <Modal.Header>
          <Modal.Title className="td-flex align-items-center mb-0">
            Permission Denied
          </Modal.Title>
          <button
            onClick={onHide}
            className="modal-close"
            aria-label="Close"
          >
            <img
              src={CrossIcon}
              alt="Close"
              style={{ width: "20px", height: "20px" }}
            />
          </button>
        </Modal.Header>
        <Modal.Body>
          <p className="fw-medium">
            You do not have the <strong>role-view</strong> permission, so you
            are unable to edit this employee.
          </p>
        </Modal.Body>
      </Modal>
    );
  }

  const employmentTypeOptions = [
    { value: "PERMANENT", label: "Permanent" },
    { value: "CONTRACTUAL", label: "Contractual" },
    { value: "PROBATION", label: "Probation" },
    { value: "TRAINEE", label: "Trainee" },
    { value: "INTERN", label: "Intern" },
  ];

  const roleOptions = roles?.map((item) => ({
    value: item.roleId,
    label: item.roleName,
  }));
  
  const desgOptions = designation?.map((item) => ({
    value: typeof item === "string" ? item : item.name,
    label: typeof item === "string" ? item : item.name,
  })) || [];
  
  const deptOptions = department?.map((item) => ({
    value: typeof item === "string" ? item : item.name,
    label: typeof item === "string" ? item : item.name,
  })) || [];
  
  const managerOptions = activeEmp
    ?.filter((item) => item.roleName !== "Employee")
    .map((item) => ({
      value: item.email,
      label: item.email,
    }));
    
  const teamLeadOptions = activeEmp
    ?.filter((item) => item.roleName !== "Employee")
    .map((item) => ({
      value: item.email,
      label: item.email,
    }));
    
  const workingModeOptions = workingModeShift?.WorkingMode?.map((item) => ({
    value: item,
    label: item,
  }));
  
  const shiftTimeOptions = workingModeShift?.ShiftType?.map((item) => ({
    value: item,
    label: item,
  }));
  
  const JobLocationOptions = [
    { value: "noida", label: "Noida" },
    { value: "gurgaon", label: "Gurgaon" },
  ];

  const handleCloseModal = () => {
    reset();
    onHide();
  };

  const handleUpdateCredential = async (data) => {
    if (!canEdit) {
      toast.error("You do not have permission to edit the credential!", {
        className: "toast-error-custom",
        autoClose: 5000,
      });
      return;
    }

    const payload = { 
      employeeDetails:{
      employeeId: employee?.employeeId,
      designation: data.desg,
      reportManager: data.reportingManager,
      teamLead: data.teamLead,
      department: data.dept,
      officeLocation: data.jobLocation,
      workingMode: data.workingMode,
      shiftTime: data.shiftTime,
      aboutUs: data.abtEmp,
      empType: data.employmentType,
    }}

   

    try {
      await dispatch(updateEmployeeProfileDetails({ employeeId, payload })).unwrap();
      await dispatch(fetchUserById(employeeId));
      handleCloseModal();
    } catch (err) {
      toast.error(err?.data?.reason || "Unable to connect to server", {
        className: "toast-error-custom",
        autoClose: 8000,
      });
    }
  };

  return (
    <Modal show={show} onHide={handleCloseModal} size="lg">
      <Modal.Header>
        <Modal.Title>Edit Employee Details</Modal.Title>
        <button onClick={handleCloseModal} className="modal-close" aria-label="Close">
          <img
            src={CrossIcon}
            alt="Close"
            style={{ width: "20px", height: "20px" }}
          />
        </button>
      </Modal.Header>
      <Form onSubmit={handleSubmit(handleUpdateCredential)} className="convert_form">
        <Modal.Body>
          <div className="row">
            <div className="col-md-6 mb-3">
              <Form.Group>
                <Form.Label className="text-muted mb-1">
                  Employee ID <span className="star">*</span>
                </Form.Label>
                <Form.Control type="text" value={employee?.employeeId} readOnly />

              </Form.Group>
            </div>
            
            <div className="col-md-6 mb-3">
              <SearchSelect
                name="employmentType"
                label={
                  <>
                    Employment Type <span className="star">*</span>
                  </>
                }
                options={employmentTypeOptions}
                rules={{ required: "Employment Type is required" }}
                placeholder="Please select the Employment Type"
                control={control}
                errors={errors}
              />
            </div>
            
            <div className="col-md-6 mb-3">
              <SearchSelect
                name="desg"
                label={
                  <>
                    Designation<span className="star">*</span>
                  </>
                }
                options={desgOptions}
                rules={{ required: "Designation is required" }}
                placeholder="Please select the designation"
                control={control}
                errors={errors}
              />
            </div>
            
            <div className="col-md-6 mb-3">
              <SearchSelect
                name="dept"
                label={
                  <>
                    Department<span className="star">*</span>
                  </>
                }
                options={deptOptions}
                rules={{ required: "Department is required" }}
                placeholder="Please select the department"
                control={control}
                errors={errors}
              />
            </div>
            
            <div className="col-md-6 mb-3">
              <SearchSelect
                name="reportingManager"
                label={
                  <>
                    Reporting Manager<span className="star">*</span>
                  </>
                }
                options={managerOptions}
                //rules={{ required: "Reporting Manager is required" }}
                placeholder="Please select the reporting manager"
                control={control}
                errors={errors}
              />
            </div>
            
            <div className="col-md-6 mb-3">
              <SearchSelect
                name="teamLead"
                label={
                  <>
                    Team Lead <span className="star">*</span>
                  </>
                }
                options={teamLeadOptions}
                //rules={{ required: "Team Lead is required" }}
                placeholder="Please select the team lead"
                control={control}
                errors={errors}
              />
            </div>
            
            <div className="col-md-6 mb-3">
              <SearchSelect
                name="workingMode"
                label={
                  <>
                    Working Mode <span className="star">*</span>
                  </>
                }
                options={workingModeOptions}
                rules={{ required: "Working Mode is required" }}
                placeholder="Please select the working mode"
                control={control}
                errors={errors}
              />
            </div>
            
            <div className="col-md-6 mb-3">
              <SearchSelect
                name="shiftTime"
                label={<>Shift</>}
                options={shiftTimeOptions}
                placeholder="Please select the shift timing"
                control={control}
                errors={errors}
              />
            </div>
            
            <div className="col-md-6 mb-3">
              <SearchSelect
                name="jobLocation"
                label={
                  <>
                    Job Location <span className="star">*</span>
                  </>
                }
                options={JobLocationOptions}
                rules={{ required: "Job Location is required" }}
                placeholder="Please select the job location"
                control={control}
                errors={errors}
              />
            </div>
            
            <div className="col-md-6 mb-3">
              <Form.Group>
                <Form.Label>About Employee</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={4}
                  {...register("abtEmp", {
                    minLength: {
                      value: 10,
                      message: "Please provide a bit more detail (at least 10 characters)",
                    },
                    maxLength: {
                      value: 500,
                      message: "Maximum 500 characters allowed",
                    },
                  })}
                />
                {errors.abtEmp && (
                  <div className="dept-error-message text-danger mt-1">
                    {errors.abtEmp.message}
                  </div>
                )}
              </Form.Group>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="cancel-cta" onClick={handleCloseModal}>
            Cancel
          </Button>
          <Button variant="update-cta" type="submit" disabled={!canEdit}>
            Update
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

EmployeeCredentialEditModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  canEdit: PropTypes.bool,
  hasRolePermission: PropTypes.bool,
  employee: PropTypes.shape({
    employeeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    empPrefix: PropTypes.string,
    designation: PropTypes.string,
    reportManager: PropTypes.string,
    teamLead: PropTypes.string,
    department: PropTypes.string,
    officeLocation: PropTypes.string,
    workingMode: PropTypes.string,
    shiftTime: PropTypes.string,
    empType: PropTypes.string,
    aboutUs: PropTypes.string,
    roleId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
};